import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'react-feather';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useCheckUserProPlanMember, useIsLoggedIn } from '../../api';
import AuthenticationPopupDialog from '../Modals/AuthenticationPopupDialog';
import CentralizeButton from '../../VuexyDesign/atoms/CentralizeButton';

function DistributionButton({ text, type }: DistributionButtonProps) {
  const router = useRouter();
  const [isAuthenticationDialogOpen, setIsAuthenticationDialogOpen] = useState(
    false,
  );
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const userLoggedIn = useIsLoggedIn();
  const isUserPro = useCheckUserProPlanMember();
  const [isNewUser, setIsNewUser] = useState(false);

  const getButtonActionCondition = () => {
    if (!userLoggedIn) {
      return 'NOT_LOGGED_IN';
    }
    if (isUserPro) {
      return 'USER_IS_PRO';
    }

    if (!isUserPro) {
      return 'USER_IS_NOT_PRO';
    }

    return '';
  };

  const distributionButtonClickHandler = () => {
    const whichConditionOnButton = getButtonActionCondition();

    if (whichConditionOnButton === 'NOT_LOGGED_IN') {
      handleAuthenticationDialogOpen();
      setIsButtonClicked(true);
    }
    if (whichConditionOnButton === 'USER_IS_NOT_PRO') {
      router.push('/become-pro');
    }
    if (whichConditionOnButton === 'USER_IS_PRO') {
      router.push('/distribution/welcome');
    }
  };

  const distributionCheckAfterAuthHandler = () => {
    const whichConditionOnButton = getButtonActionCondition();
    if (whichConditionOnButton === 'USER_IS_NOT_PRO') {
      router.push(
        `/become-pro${isNewUser ? '?newuser=true&fire_ga=true' : ''}`,
      );
    }
    if (whichConditionOnButton === 'USER_IS_PRO') {
      router.push('/distribution/welcome');
    }
  };

  useEffect(() => {
    if (userLoggedIn && isButtonClicked) {
      distributionCheckAfterAuthHandler();
    }
  }, [userLoggedIn]);

  const handleAuthenticationDialogClose = () => {
    setIsAuthenticationDialogOpen(false);
  };
  const handleAuthenticationDialogOpen = () => {
    setIsAuthenticationDialogOpen(true);
  };

  const getButton = () => {
    if (type === 'GRADIENT_FILLED') {
      return (
        <>
          <CentralizeButton
            onClick={distributionButtonClickHandler}
            icon={ArrowRight}
            text={text}
            color="gradient"
            size="md"
          />
        </>
      );
    }

    if (type === 'GRADIENT_OUTLINE') {
      return (
        <CentralizeButton
          onClick={distributionButtonClickHandler}
          icon={GradientArrow}
          text={text}
          outline
          color="gradient"
          size="md"
        />
      );
    }

    if (type === 'GET_STARTED_WHITE') {
      return (
        <CentralizeButton
          onClick={distributionButtonClickHandler}
          icon={ArrowRight}
          text={text}
          color="white"
          size="lg"
          className="mt-2"
        />
      );
    }

    return (
      <CentralizeButton
        onClick={distributionButtonClickHandler}
        icon={ArrowRight}
        text={text}
        color="gradient"
        size="md"
      />
    );
  };

  return (
    <>
      {getButton()}
      <AuthenticationPopupDialog
        isOpen={isAuthenticationDialogOpen}
        onClose={handleAuthenticationDialogClose}
        setIsNewUser={setIsNewUser}
      />
    </>
  );
}

const GradientArrow = styled(ArrowRight)`
  color: #5246c5;
`;

export default DistributionButton;

interface DistributionButtonProps {
  text: string;
  type: string;
}
